import React from "react";
// import "./loader.css";
const Loader = () => {
  return (
    <div className="kabobloader">
      <div className="bounce1"></div>
      <div className="bounce2"></div>
      <div className="bounce3"></div>
    </div>
  );
};

export default Loader;
